import Id from './Id';
import Name from './Name';
import Description from './Description';
import Category from './Category';
import Status from './Status';
import MinStock from './MinStock';
import CTN from './CTN';
import NetPrice from './NetPrice';
import Price from './Price';
import RetailerPrice from './RetailerPrice';
import WebPrice from './WebPrice';
import MinPrice from './MinPrice';
import Vat from './Vat';
import Billable from './Billable';
import Suppliers from './Suppliers';
import Updated from './Updated';
import Created from './Created';
import AvailableForRepresentative from './AvailableForRepresentative';
import OriginCountry from './OriginCountry';
import UsabilityDays from './UsabilityDays';

export const labels = {
  Id: 'Azonosító',
  Name: 'Terméknév',
  Description: 'Leírás',
  Category: 'Kategória',
  Status: 'Státusz',
  MinStock: 'Kritikus készlet',
  CTN: 'VTSZ',
  NetPrice: 'Alapár',
  Price: 'Bruttó Alapár',
  RetailerPrice: 'Kisker ár',
  WebPrice: 'Web ár',
  MinPrice: 'Padló ár',
  Vat: 'Áfa',
  Billable: 'Számlázandó',
  AvailableForRepresentative: 'Képviselő rendelheti',
  Suppliers: 'Beszállítók',
  OriginCountry: 'Származási ország',
  UsabilityDays: 'Szavatosság nap',
  Created: 'Létrehozva',
  Updated: 'Módosítva',
};

export const allColumns = [{
  value: 'Id',
  fixed: true,
}, {
  value: 'Name',
  fixed: true,
}, {
  value: 'Description',
}, {
  value: 'Category',
}, {
  value: 'Status',
}, {
  value: 'MinStock',
}, {
  value: 'CTN',
}, {
  value: 'NetPrice',
}, {
  value: 'Price',
}, {
  value: 'RetailerPrice',
}, {
  value: 'WebPrice',
}, {
  value: 'MinPrice',
}, {
  value: 'Vat',
}, {
  value: 'Billable',
}, {
  value: 'AvailableForRepresentative',
}, {
  value: 'Suppliers',
}, {
  value: 'UsabilityDays',
}, {
  value: 'OriginCountry',
}, {
  value: 'Updated',
}, {
  value: 'Created',
}];

export const defaultColumns = [{
  value: 'Id',
  fixed: true,
}, {
  value: 'Name',
  fixed: true,
}, {
  value: 'Category',
}, {
  value: 'Status',
}, {
  value: 'Suppliers',
}];

export const defaultSort = {
  prop: Name.propName,
  order: 'ascending'
};

export default {
  Id,
  Name,
  Description,
  Category,
  Status,
  MinStock,
  CTN,
  NetPrice,
  Price,
  RetailerPrice,
  WebPrice,
  MinPrice,
  Vat,
  Billable,
  AvailableForRepresentative,
  Suppliers,
  UsabilityDays,
  OriginCountry,
  Updated,
  Created,
};
